var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeOpeninline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 16 16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.1 7.5c2-3.6 4.7-5.5 7.9-5.5s5.9 1.9 7.9 5.5c.2.3.2.7 0 1-2.3 3.6-4.9 5.5-7.9 5.5s-5.6-1.9-7.9-5.5c-.1-.3-.2-.7 0-1zm5-1.4c.3.5.8.9 1.4.9.8 0 1.5-.7 1.5-1.5 0-.6-.4-1.1-.9-1.4.3-.1.6-.1.9-.1 1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3c0-.3 0-.6.1-.9zm.1-1.4c-1.1.7-2.1 1.8-3 3.3 1.8 2.7 3.7 4 5.8 4s4-1.3 5.8-4c-1.6-2.7-3.5-4-5.8-4-.3 0-.7 0-1 .1-.2-.1-.3-.1-.5-.1-.6 0-1 .3-1.3.7z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeOpeninline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye-open.inline.c53c6ed6d3d278daa1722a9b612a63b3.svg";